import React from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { BreadcrumbProps, Button, Icon, Tooltip } from '@aidkitorg/component-library'
import { useLocalizedStrings } from '../../Localization'
import { DashboardsDataTable } from './components/DashboardsDataTable'
import { useHistory } from 'react-router-dom'

export const DashboardsPage = () => {
  const L = useLocalizedStrings()
  const history = useHistory()

  const pageActionButtons = [
    <Tooltip text={L.admin_panel.dashboards.manage_target_fields} asChild>
      <Button
        variant="secondary"
        onClick={() => {
          history.push('/admin-panel/settings/manage-fields')
        }}
        icon={<Icon
          name="CogIcon"
          type="solid"
          role="decorative"
        />}
      />
    </Tooltip>,
    <Button 
      onClick={() => {
        history.push('/admin-panel/dashboards/new')
      }}
      icon={<Icon
        name="PlusIcon"
        type="solid"
        role="decorative"
      />}
    >
      {L.admin_panel.dashboards.create_new}
    </Button>
  ]

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.dashboards
    }
  ]

  return (
    <AdminPanelPage
      title={L.admin_panel.dashboards.dashboards} 
      pageActionButtons={pageActionButtons}
      breadcrumbs={breadcrumbs}
      keyboardShortcuts={[
        { key: '/', description: L.admin_panel.dashboards.search },
        { key: 'B', description: L.admin_panel.reports.toggle_sidebar, modifier: 'meta' },
        { key: 'K', description: L.admin_panel.command_palette.keyboard_shortcut, modifier: 'meta' },
      ]}
    >
      <DashboardsDataTable />
    </AdminPanelPage>
  )
}